module.exports = __webpack_public_path__ + "static/media/CAFFENIO_black.c30ae912.svg";